module.exports = __webpack_public_path__ + "static/img/DSC_0012.cad99c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_0012.jpg
// module id = XPsl
// module chunks = 0